<template>
    <div>
        <div
            class="relative h-full w-full p-32 py-72 flex items-center justify-center ct-bg-1"
        ></div>
        <CoffeeBody
            v-if="coffee.uuid"
            :coffee="coffee"
            @updateIframeHeight="updateHeight"
            @updateIframeView="updateView"
        />
    </div>
</template>

<script>
import { mapMutations } from "vuex";
import CoffeeBody from "@/views/tools/coffee/CoffeeBody.vue";
import { setFontFamily, updateIframeHeight, updateIframeView } from "@/shared/utils";
import { prepareCoffee } from "@/shared/projects/prepareData";
import { PREVIEW_ROUTE_NAMES } from "@/views/preview/preview.routes";
import { projectsService } from "@/shared/projects/projects.service";
import { useRenderPreviewStore } from "@/views/store/render-preview.store";

export default {
    name: "CoffeesPreview",
    components: {
        CoffeeBody,
    },
    setup() {
        const { setIsPreview } = useRenderPreviewStore();
        return { setIsPreview };
    },
    data() {
        return {
            coffee: {},
            windowWidth: window.innerWidth,
            currentFont: "Inter",
            waiting: false,
        };
    },
    async mounted() {
        if (window.location === window.parent.location) {
            try {
                this.coffee = await this.loadCoffee(this.$route.params.coffee_uuid);
                this.adjustIframe();
            } catch {
                this.$router.push({ name: PREVIEW_ROUTE_NAMES.notFound });
            }
        } else {
            window.addEventListener("message", this.refreshIframe);
        }

        window.addEventListener("resize", this.resizeIframe);
    },
    beforeUnmount() {
        window.removeEventListener("message", this.refreshIframe);
        window.removeEventListener("resize", this.resizeIframe);
    },
    methods: {
        ...mapMutations("shared/view", ["setPreview"]),
        async loadCoffee(uuid) {
            this.waiting = true;
            const coffee = await projectsService.getOne({ tool: "coffee", uuid });
            this.waiting = false;
            return prepareCoffee(coffee);
        },
        refreshIframe(e) {
            if (e.data.coffeeData) {
                this.coffee = prepareCoffee(e.data.coffeeData);
                this.adjustIframe();
            }
            if (e.data.showPreview) {
                this.setPreview(e.data.showPreview === "off" ? false : true);
                this.setIsPreview(e.data.showPreview !== "off");
            }
        },
        async adjustIframe() {
            this.currentFont = setFontFamily(this.coffee.fontFamily, this.currentFont);
            await this.$nextTick();
            this.toggleAdjust();
            this.updateHeight();
        },
        updateHeight() {
            updateIframeHeight("coffee", this.coffee.uuid);
        },
        updateView(view) {
            updateIframeView("coffee", this.coffee.uuid, view);
        },
        resizeIframe() {
            if (window.innerWidth !== this.windowWidth) {
                this.adjustIframe();
                this.windowWidth = window.innerWidth;
            }
        },
        toggleAdjust() {
            const adjust = document.querySelector("[data-ecoffee-adjust]");
            if (adjust.classList.contains("hidden")) {
                adjust.classList.remove("hidden");
                setTimeout(() => {
                    adjust.classList.remove("opacity-0");
                }, 100);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.logo {
    display: block;
    margin: auto;
    width: 120px;
    height: 120px;
    transition: all 0.5s ease-in-out;
    opacity: 1;
    transform: rotate(0deg);
}
</style>
